import type { DeductibleOption } from './map-deductible-options.util';

/**
 * Franquia que pode ser marcada sem perguntar ao corretor: o seletor tem UMA
 * opção só para o LMI informado e nada está escolhido ainda. Uma seleção que já
 * existe (do corretor ou da cotação salva) nunca é trocada.
 */
export function resolveSingleDeductibleOption(
  options: Pick<DeductibleOption, 'value'>[],
  selectedValue: string | undefined
): string | undefined {
  if (options.length !== 1) return undefined;
  if ((selectedValue ?? '').trim().length > 0) return undefined;
  return options[0].value;
}
